import React from "react";
import { iconProps } from "../../Helper";

const ReplaceIcon = ({className}:iconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10949_21093"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10949_21093)">
        <path
        className={className}
          d="M3.60518 16.3943V15.1443H6.04102L5.43518 14.5643C4.75046 13.9307 4.26359 13.2215 3.97456 12.4368C3.68553 11.6521 3.54102 10.8591 3.54102 10.0578C3.54102 8.61769 3.96275 7.3263 4.80622 6.18367C5.6497 5.04103 6.75574 4.25658 8.12435 3.83033V5.14762C7.11893 5.54068 6.31206 6.18464 5.70372 7.0795C5.09525 7.97422 4.79102 8.967 4.79102 10.0578C4.79102 10.7095 4.91442 11.3425 5.16122 11.9568C5.40803 12.5711 5.79213 13.1389 6.31352 13.6603L6.84227 14.1893V11.9072H8.09227V16.3943H3.60518ZM11.8743 16.1699V14.8526C12.8798 14.4596 13.6866 13.8156 14.295 12.9207C14.9034 12.026 15.2077 11.0332 15.2077 9.94242C15.2077 9.29075 15.0843 8.65776 14.8375 8.04346C14.5907 7.42915 14.2066 6.8613 13.6852 6.33992L13.1564 5.81096V8.09304H11.9064V3.60596H16.3935V4.85596H13.9577L14.5635 5.43596C15.2227 6.09526 15.7032 6.81082 16.005 7.58262C16.3068 8.35457 16.4577 9.14117 16.4577 9.94242C16.4577 11.3826 16.0359 12.6739 15.1925 13.8166C14.349 14.9592 13.243 15.7437 11.8743 16.1699Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default ReplaceIcon;
